import React, { useContext, useState } from "react";
import ToggleField from "../../../Components/ToggleField";
import TextInput from "../../../Components/TextInput";
import { FormField } from "../../../Components/FormField";
import { ErrorMessage, Form, Formik } from "formik";
import { LazyLoadImage } from "react-lazy-load-image-component";
import SidebarField from "../../../Components/SidebarField";
import Button from "../../../Components/Button";
import ImagePreview from "../../../Components/ImagePreview";
import LoaderContext from "../../../Components/loader";
import { CategoryApi } from "../../../App/api/menu.apis";
import SelectDropdown from "../../../Components/Dropdown/SelectDropdown";
import { useFetchAll } from "../../../custom/FetchApiHook";
import { DeliveryApi } from "../../../App/api/DeliveryFee.apis";
import validationSchema from "./ValidationSchema";
import CreateForm from "../../../Components/DynamicForm/CreateForm";
import { toast } from "react-toastify";

function AddCategory({ currentItems, open, handleClose, approve }) {
  const deliveryData = useFetchAll(() => DeliveryApi.getAllDeliveryFeeData());
  
  const deliveryOptions = deliveryData.value?.data?.length
    ? deliveryData?.value?.data?.map((item) => {
        item.name = `${item?.regionType?.regionType} > ${
          item?.deliveryType?.name
        } > ${item?.factor?.map((item) => `${item.name}`)}`;
        return item;
      })
    : [];

  const [step, setStep] = useState(0);

  const { handleLoading } = useContext(LoaderContext);

  const initialValues = {
    name: currentItems?.name || "",
    image: currentItems?.image || null,
    delivery_calculation: currentItems?.delivery_calculation || "",
    categoryType: currentItems?.categoryType || "Ecommerce",
    sequence: currentItems?.sequence || 0,
    is_visible: currentItems?.is_visible || true,
    isDynamicFields: currentItems?.isDynamicFields || false,
    dynamicFields: currentItems?.dynamicFields || [],
    nutritionalFields: currentItems?.nutritionalFields || [],
  };
  const [error, setError] = useState("");
  const handleFileUpload = (e, setFieldValue) => {
    const file = e.target.files[0];

    if (file) {
      // Check if file size exceeds 1MB
      const fileSizeInMB = file.size / 1024 / 1024;
      if (fileSizeInMB > 1) {
        setError("Please select an image smaller than 1MB.");
        setFieldValue("image", null);
        return;
      }

      // Clear error and set the file if size is valid
      setError("");
      setFieldValue("image", file);
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    console.log(values);

    handleLoading(true);
    try {
      const res = currentItems?._id
        ? await CategoryApi.updateCategory(values, currentItems?._id)
        : await CategoryApi.createCategory(values);
    } catch (err) {
      console.log(err);
    } finally {
      handleLoading(false);
      resetForm();
      handleClose();
      setStep(0);
    }
  };

  const handleBack = () => {
    setStep((prevStep) => Math.max(prevStep - 1, 0));
    // console.log("step:",step);
  };

  //   adding toast
  const handleNext = (e, values) => {
    e.preventDefault();
    if (values.image === null) {
      toast.error("Image is required");
      return;
    }
    if (values.delivery_calculation === null) {
      toast.error("Delivery calculation is required");
      return;
    }
    if (values.name === "") {
      toast.error("Name is required");
      return;
    }
    setStep((prevStep) => Math.max(prevStep + 1, 1));
  };

  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ handleChange, values, handleSubmit, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={
                  approve
                    ? "Approve"
                    : currentItems?._id
                    ? `Update Category`
                    : `Add New Category`
                }
                // button1={
                //   <Button text="Cancel" type="button" onClick={handleClose} />
                // }
                // button2={
                //   <Button
                //   type="submit"
                //     text={
                //       approve ? "Approve" : currentItems?._id ? "Update" : "Add"
                //     }
                //   />
                // }
                button1={
                  step === 0 ? (
                    <Button text="Cancel" type="button" onClick={handleClose} />
                  ) : (
                    <Button text="Back" type="button" onClick={handleBack} />
                  )
                }
                button2={
                  <Button
                    text={step === 1 ? "Submit" : "Next "}
                    type="submit"
                    onClick={(e) =>
                      step === 1
                        ? handleSubmit(e, values)
                        : handleNext(e, values)
                    }
                  />
                }
                button3={
                  <Button
                    type="submit"
                    text={
                      approve ? "Approve" : currentItems?._id ? "Update" : "Add"
                    }
                  />
                }
              >
                {step === 0 ? (
                  <>
                    <FormField
                      label="Category Name"
                      tooltip="enter your category"
                    >
                      <div className="flex items-center">
                        <span className="border p-2 pl-3 pr-5 text-sm border-r-none">
                          EN
                        </span>
                        <TextInput
                          name="name"
                          type="text"
                          placeholder="Category"
                          value={values.name}
                          onChange={handleChange}
                        />
                      </div>
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="error"
                      />
                    </FormField>

                    <div className="my-2">
                      {typeof values.image === "object" ? (
                        <ImagePreview file={values.image} id="image" />
                      ) : (
                        <LazyLoadImage
                          src={
                            values.image ||
                            "https://storeedelivery.elluminatiinc.net/assets/img/default_images/category.png"
                          }
                          alt="category-item"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                        />
                      )}

                      <span className="text-[12px] text-gray-400  flex w-full">
                        <label htmlFor="image-upload" className="w-full flex ">
                          <TextInput
                            name="image"
                            type="file"
                            placeholder="Choose File"
                            id="image-upload"
                            onChange={(e) => handleFileUpload(e, setFieldValue)}
                          />
                          <button
                            className="border px-5 cursor-pointer z-5 "
                            type="file"
                            id="image-upload"
                          >
                            Browse
                          </button>
                        </label>
                      </span>
                      <ErrorMessage
                        name="image"
                        component="div"
                        className="error"
                      />
                    </div>
                    {error && (
                      <p className="text-red-500 text-sm mt-2">{error}</p>
                    )}
                    <div>
                      <ToggleField
                        text="Is category visible to user?"
                        name="is_visible"
                        value={values.is_visible}
                      />
                      <ErrorMessage
                        name="is_visible"
                        component="div"
                        className="error"
                      />
                    </div>

                {/* <FormField label="Category Type" tooltip="Choose Category Type">
                  <SelectDropdown
                    sx={{ borderRadius: "3px", height: "2.6rem" }}
                    value={values.categoryType || ""}
                    inputName="categoryType"
                    placeholder="Select Category Type"
                    options={[{ name: "Ecommerce" }, { name: "Food" }]}
                    optionLabel="name"
                    optionValue="name"
                    handleFilter={(name, v) => setFieldValue("categoryType", v)}
                  />
                  <ErrorMessage
                    name="categoryType"
                    component="p"
                    className="error"
                  />
                </FormField> */}
                <FormField label="Delivery Type" tooltip="Choose Delivery Type">
                  <SelectDropdown
                    sx={{ borderRadius: "3px", height: "2.6rem" }}
                    value={values.delivery_calculation || ""}
                    inputName="delivery_calculation"
                    placeholder="Select Delivery Type"
                    options={deliveryOptions || []}
                    optionLabel="name"
                    optionValue="_id"
                    handleFilter={(name, v) =>
                      setFieldValue("delivery_calculation", v)
                    }
                  />
                  <ErrorMessage
                    name="delivery_calculation"
                    component="p"
                    className="error"
                  />
                </FormField>
                {/* delivery calculation fields @start */}

                    {values.delivery_calculation
                      ? deliveryData.value.data
                          .filter(
                            (item) => item._id === values.delivery_calculation
                          )
                          .map((item) => (
                            <>
                              <>
                                <FormField
                                  label="Additional Fee"
                                  tooltip="Additional Fee"
                                >
                                  <TextInput
                                    name="additionalFee"
                                    type="number"
                                    value={item.additionalFee}
                                    // onChange={handleChange}
                                    disabled={true}
                                  />
                                </FormField>
                                <FormField
                                  label="Closing Fee Rate"
                                  tooltip="Closing Fee Rate"
                                >
                                  <TextInput
                                    name="closingFeeRate"
                                    type="number"
                                    value={item.closingFeeRate}
                                    // onChange={handleChange}
                                    disabled={true}
                                  />
                                </FormField>
                                <FormField
                                  label="Referral Fee Rate"
                                  tooltip="Referral Fee Rate"
                                >
                                  <TextInput
                                    name="referralFeeRate"
                                    type="number"
                                    value={item.referralFeeRate}
                                    // onChange={handleChange}
                                    disabled={true}
                                  />
                                </FormField>
                                <FormField
                                  label="Shipping Fee Rate"
                                  tooltip="Shipping Fee Rate"
                                >
                                  <TextInput
                                    name="shippingFeeRate"
                                    type="number"
                                    value={item.shippingFeeRate}
                                    // onChange={handleChange}
                                    disabled={true}
                                  />
                                </FormField>
                                <FormField
                                  label="Shipping Handling Fee Fixed Rate"
                                  tooltip="Shipping Handling Fee Fixed Rate"
                                >
                                  <TextInput
                                    name="shippingHandlingFeeFixedRate"
                                    type="number"
                                    value={item.shippingHandlingFeeFixedRate}
                                    // onChange={handleChange}
                                    disabled={true}
                                  />
                                </FormField>
                                {item.factor.map((d) => (
                                  <FormField
                                    label={`${d.name}`}
                                    tooltip={`${d.name}`}
                                  >
                                    <TextInput
                                      name="shippingHandlingFeeFixedRate"
                                      type="number"
                                      value={d.value}
                                      // onChange={handleChange}
                                      disabled={true}
                                    />
                                  </FormField>
                                ))}
                              </>
                            </>
                          ))
                      : ""}

                    {/* delivery calculation fields @end */}
                    {/* <FormField
                          label="Sequence Number"
                          tooltip="enter your sequence number"
                        >
                          <TextInput
                            name="sequence"
                            type="number"
                            value={values.sequence}
                            onChange={handleChange}
                          />
                        </FormField>    
                                            */}
                    <div>
                      <ToggleField
                        text="Category Specific Fileds?"
                        name="isDynamicFields"
                        value={values.isDynamicFields}
                        toggaleHandleChange={(v) => {
                          setFieldValue(
                            "isDynamicFields",
                            !values.isDynamicFields
                          );
                          values.isDynamicFields &&
                            setFieldValue("dynamicFields", []);
                        }}
                      />
                      <ErrorMessage
                        name="isDynamicFields"
                        component="div"
                        className="error"
                      />
                    </div>
                    {values.isDynamicFields ? (
                      <CreateForm
                        values={values.dynamicFields}
                        onCreateForm={(data) =>
                          setFieldValue("dynamicFields", data)
                        }
                      />
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  <>
                    <h1 className="text-2xl">
                      Add Category Specific Nutritional Fields
                    </h1>
                    <CreateForm
                      values={values.nutritionalFields}
                      inputType4="nutritionalFields"
                      onCreateForm={(data) =>
                        setFieldValue("nutritionalFields", data)
                      }
                    />
                  </>
                )}
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default AddCategory;
